import React from "react";

export function Textarea({ invalid = false, disabled = false, rows = 3, style = {}, ...rest }) {
  const [focus, setFocus] = React.useState(false);
  return (
    <textarea
      rows={rows}
      disabled={disabled}
      onFocus={(e) => { setFocus(true); rest.onFocus?.(e); }}
      onBlur={(e) => { setFocus(false); rest.onBlur?.(e); }}
      style={{
        width: "100%", padding: "11px 16px", fontFamily: "var(--font-body)",
        fontSize: "var(--text-base)", lineHeight: "var(--leading-normal)",
        color: "var(--text-body)", background: disabled ? "var(--surface-muted)" : "var(--surface-raised)",
        border: `1.5px solid ${invalid ? "var(--danger)" : focus ? "var(--hive)" : "var(--border-default)"}`,
        borderRadius: "var(--radius-sm)", outline: "none", resize: "vertical",
        boxShadow: focus ? "var(--shadow-focus-input)" : "none",
        transition: "border-color var(--duration-fast) var(--ease-out), box-shadow var(--duration-fast) var(--ease-out)",
        ...style,
      }}
      {...rest}
    />
  );
}
